import { ROUTES } from "../../../helpers/routes";
import login from "../../../images/header/login.svg";
import register from "../../../images/header/register.svg";
import profileIcon from "../../../images/header/profile.svg";

export const routesNoAuth = [
  {
    name: "HOME",
    path: ROUTES.home,
  },
  {
    name: "MODELS",
    path: ROUTES.models,
  },
  {
    name: "CLUBS",
    path: ROUTES.clubs,
  },
  {
    icon: login,
    name: "LOGIN",
    path: ROUTES.login,
  },
  {
    icon: register,
    name: "REGISTER",
    path: ROUTES.register,
  },
];

export const routesAuth = [
  {
    name: "HOME",
    path: ROUTES.home,
  },
  {
    name: "MODELS",
    path: ROUTES.models,
  },
  {
    name: "CLUBS",
    path: ROUTES.clubs,
  },
  {
    icon: profileIcon,
    name: "Profile",
    path: ROUTES.modelPanel,
  },
];
